:host {
  display: block;

  .gender-disclaimer-container {
    position: fixed;
    bottom: -100%;
    left: 0;
    width: 100%;
    background: white;
    border-top: 3px solid var(--color-primary);
    transition: bottom 0.5s ease-in-out;
    z-index: 100;
  }

  .visible {
    bottom: 0;
  }

  .gender-disclaimer {
    padding: 1rem;
    margin: auto;
    max-width: 1140px;
    position: relative;
  }

  .close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: var(--color-primary);
    font-size: 22px;
    cursor: pointer;
  }
}
